/* ==========================================================================
   SCROLL-REVEAL VOOR DE HEADER
   --------------------------------------------------------------------------
   Scroll naar beneden -> de header schuift als één blok omhoog uit beeld.
   Scroll omhoog -> hij glijdt direct terug, in iets compactere staat.
   Boven de 80px blijft hij altijd zichtbaar.

   Afstemmen: de drie getallen onderaan in dit bestand.
   ========================================================================== */

(function () {
  var DELTA_MIN = 4; /* px — kleinere scrollbewegingen negeren we */
  var CONDENSE_AT = 8; /* px — vanaf hier wordt de header compacter */
  var ALWAYS_VISIBLE_UNTIL = 80; /* px — daaronder blijft hij altijd staan */

  var shell = document.querySelector('[data-scroll-reveal]');
  if (!shell) return;

  var last = window.scrollY;
  var frame = 0;

  function update(initial) {
    var y = window.scrollY;
    var delta = y - last;

    /* Bij het eerste rondje is delta 0; dan tóch bijwerken, anders klopt de
       stand niet wanneer de pagina halverwege geopend wordt (herladen,
       terugknop, of een link naar een anker). */
    if (!initial && Math.abs(delta) < DELTA_MIN) return;

    shell.classList.toggle('is-condensed', y > CONDENSE_AT);

    if (y < ALWAYS_VISIBLE_UNTIL) {
      shell.classList.remove('is-hidden');
    } else if (shell.classList.contains('lp-header--open')) {
      /* Menu open: laat de header staan. Anders schuift het paneel waar de
         bezoeker in bezig is mee omhoog uit beeld. */
      shell.classList.remove('is-hidden');
    } else if (delta > 0) {
      shell.classList.add('is-hidden');
    } else {
      shell.classList.remove('is-hidden');
    }

    last = y;
  }

  function onScroll() {
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = 0;
      update(false);
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update(true);
})();
